import { z } from "zod";

import { schemes } from "../schema-validation";
import { laForgeWorkLocationSchema } from "../work-locations/schemas/laForgeWorkLocation";
import { baseEventInput } from "./baseEvent";

export const companyWorkLocationEvent = baseEventInput.merge(
  z.object({
    source: z.literal("company.worklocations"),
    // this is a quark company id
    companyId: schemes.mongoObjectId(),
    payload: laForgeWorkLocationSchema,
  })
);

export type CompanyWorkLocationEvent = z.infer<typeof companyWorkLocationEvent>;
